/**
 * @flow
 * @relayHash 7441cfec334f6680143a04582d792619
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type routes1_ResetLogin_QueryVariables = {|
  token: string
|};
export type routes1_ResetLogin_QueryResponse = {|
  +person: {|
    +id: string,
    +name: string,
  |}
|};
*/


/*
query routes1_ResetLogin_Query(
  $token: String!
) {
  person: claimReset(token: $token) {
    id
    name
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "token",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": "person",
    "name": "claimReset",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "token",
        "variableName": "token",
        "type": "String!"
      }
    ],
    "concreteType": "User",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "routes1_ResetLogin_Query",
  "id": null,
  "text": "query routes1_ResetLogin_Query(\n  $token: String!\n) {\n  person: claimReset(token: $token) {\n    id\n    name\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "routes1_ResetLogin_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "routes1_ResetLogin_Query",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4f2efe5f082c0bd5b413ab42426ac88e';
module.exports = node;
